var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Search } from "@mui/icons-material";
import { Box, Chip, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilterIcon } from "../../../assets/customIcons";
import { getUpdateKey } from "../../../builderPackage/common/commonFunctions";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { setReducerState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { ContractSaleOrderKeys } from "../../contractSaleOrder/services/entity";
import JCI_returnCatalogueView from "../component/JCI_returnCatalogueView";
import CancelledCatalogueView from "../component/CancelledCatalogueView";
import Jci_returnMobileView from "../component/jci_returnMobileView";
import Jci_ReturnInvoiceMobileView from "../component/jci_ReturnInvoiceMobileView";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { JobCardInvoiceReturnFilter } from "../component/jciReturnFilter";
// import { ContractSaleInvoiceCatalogueInvoicedMobileView } from "./components/contractSaleInvoiceCatalogueInvoicedMobileView";
// import { ContractSaleInvoiceCatalogueOpenMobile } from "./components/contractSaleInvoiceCatalogueOpenMobile";
// import InvoicedCatalogueView from "./components/invoicedCatalogueView";
// import OpenOrderCatalogueView from "./components/openOrderCatalogueView";
// import ReturnedCatalogueView from "./components/returnedCatalogueView";
// import { InvoiceCountAPI } from "./services/apiCall";
// import { ContractInvoiceKeys } from "./services/entity";
var JciReturnNew = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3;
    var _a = useState(false), isFilterOpen = _a[0], setFilterOpen = _a[1];
    var _b = useState('list'), activeView = _b[0], setActiveView = _b[1];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var IdentityId = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.IdentityId;
    var crud = useAppSelector(function (state) { return state.crud; });
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var listVariants = [{
            Name: "My Job card invoice return",
            id: IdentityId
        }, {
            Name: 'All Job card invoice return',
            id: 'all'
        }];
    var invoicedCatalogueView = [{
            type: FormItemTypes.Custom,
            name: 'open',
            columnSize: 12,
            element: IS_MOBILE ? Jci_returnMobileView : JCI_returnCatalogueView
        }];
    var invoicedCancelledCatalogueView = [{
            type: FormItemTypes.Custom,
            name: 'invoiced',
            columnSize: 12,
            element: IS_MOBILE ? Jci_ReturnInvoiceMobileView : CancelledCatalogueView
        }];
    var handleOnClick = function () {
        navigate('/createContractSaleInvoice');
    };
    var formData = [{
            type: FormItemTypes.SingleSelect,
            name: 'IdentityId',
            value: 'all',
            options: listVariants,
            valueExpr: 'id',
            displayExpr: 'Name',
            size: 'medium',
            columnSize: 0,
            disableUnderline: true,
            variant: 'standard',
            sx: {
                color: 'text.primary',
                m: 1,
                fontWeight: 'strong',
                fontSize: '20px !important',
                bgcolor: 'secondary.50'
            }
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            })
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Value',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by VIN, Reg No, Doc No..',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: IS_MOBILE ? 2 : 9,
                    gap: IS_MOBILE ? '0px' : '12px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: "".concat(!IS_MOBILE ? "Filters" : ''),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: JobCardInvoiceReturnFilter,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            width: {
                                                                xs: '100%',
                                                                sm: '350px'
                                                            },
                                                            borderRadius: {
                                                                xs: '8px 8px 0 0'
                                                            }
                                                        }
                                                    },
                                                    anchor: IS_MOBILE ? 'bottom' : 'right'
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Status',
            columnSize: 12,
            valueExpr: 'id',
            sx: {
                px: 2
            },
            displayExpr: 'Name',
            panelGridProps: {
                spacing: 2,
                pb: '65px'
            },
            tabs: [{
                    id: 'openOrder',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Invoiced"), /*#__PURE__*/ React.createElement(Chip
                    // label={crud[ContractInvoiceKeys.ContractSaleInvoiceCount]?.data?.Open ?? '0'}
                    , {
                        label: '0',
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    elements: invoicedCatalogueView
                }, {
                    id: 'CancelledInvoices',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Returned Invoices"), /*#__PURE__*/ React.createElement(Chip
                    // label={crud[ContractInvoiceKeys.ContractSaleInvoiceCount]?.data?.Invoiced ?? '0'}
                    , {
                        label: '10',
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    elements: invoicedCancelledCatalogueView
                }]
        }];
    var handleClickFilterIcon = function () {
        setFilterOpen(true);
    };
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit"
        // getFormAPI={InvoiceCountAPI}
        // getKey={ContractInvoiceKeys.ContractSaleInvoiceCount}
        ,
        getRequest: {
            OrganizationId: UserOrganization,
            ParentOrganizationId: UserParentOrganization
        },
        onChange: function (e, _ref) {
            var state = _ref.state, field = _ref.field, value = _ref.value;
            if ((state === null || state === void 0 ? void 0 : state.Status) == "invoiced") {
                // if (field && value) dispatch(setReducerState({ key: getUpdateKey(ContractInvoiceKeys.Paging), value: true }))
            }
            else if ((state === null || state === void 0 ? void 0 : state.Status) == "openOrder") {
                if (field && value)
                    dispatch(setReducerState({
                        key: getUpdateKey(ContractSaleOrderKeys.Paging),
                        value: true
                    }));
            }
        }
    }));
};
export default JciReturnNew;
